<iframe
  style="width: 100%; height: 99.2%; border: 0px"
  src="https://v2.npaper.com.br"
></iframe>
